import { render } from "./HelpScreens.vue?vue&type=template&id=ab4ef08c&scoped=true"
import script from "./HelpScreens.vue?vue&type=script&lang=js"
export * from "./HelpScreens.vue?vue&type=script&lang=js"

import "./HelpScreens.vue?vue&type=style&index=0&id=ab4ef08c&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ab4ef08c"]])

export default __exports__